module.exports = __webpack_public_path__ + "assets/img/tha.8461de61.png";